import {
  STACK_COLOR_DEFAULT_ACCENT,
  STACK_COLOR_DEFAULT_BACKGROUND,
  STACK_PALETTE_01_ACCENT,
  STACK_PALETTE_01_BACKGROUND,
  STACK_PALETTE_02_ACCENT,
  STACK_PALETTE_02_BACKGROUND,
  STACK_PALETTE_03_ACCENT,
  STACK_PALETTE_03_BACKGROUND,
  STACK_PALETTE_04_ACCENT,
  STACK_PALETTE_04_BACKGROUND,
  STACK_PALETTE_05_ACCENT,
  STACK_PALETTE_05_BACKGROUND,
  STACK_PALETTE_06_ACCENT,
  STACK_PALETTE_06_BACKGROUND,
  STACK_PALETTE_07_ACCENT,
  STACK_PALETTE_07_BACKGROUND,
  STACK_PALETTE_08_ACCENT,
  STACK_PALETTE_08_BACKGROUND,
  STACK_PALETTE_09_ACCENT,
  STACK_PALETTE_09_BACKGROUND,
  STACK_PALETTE_10_ACCENT,
  STACK_PALETTE_10_BACKGROUND,
} from './constants';

export interface StackColorMapping {
    accent: string;      // Border color (stored in backend)
    background: string;  // Footer background color (lighter shade)
  }
  
  export const DEFAULT_COLOR_MAPPING: StackColorMapping = {
    accent: STACK_COLOR_DEFAULT_ACCENT,
    background: STACK_COLOR_DEFAULT_BACKGROUND,
  };

  /**
   * Pre-defined color palette mapping for optimal lighter shades
   * These are hand-picked for best visual appearance
   */
  const STACK_COLOR_MAPPING: Record<string, StackColorMapping> = {
        [STACK_PALETTE_01_ACCENT]: {
      accent: STACK_PALETTE_01_ACCENT,
      background: STACK_PALETTE_01_BACKGROUND,
    },
    [STACK_PALETTE_02_ACCENT]: {
      accent: STACK_PALETTE_02_ACCENT,
      background: STACK_PALETTE_02_BACKGROUND,
    },
    [STACK_PALETTE_03_ACCENT]: {
      accent: STACK_PALETTE_03_ACCENT,
      background: STACK_PALETTE_03_BACKGROUND,
    },
    [STACK_PALETTE_04_ACCENT]: {
      accent: STACK_PALETTE_04_ACCENT,
      background: STACK_PALETTE_04_BACKGROUND,
    },
    [STACK_PALETTE_05_ACCENT]: {
      accent: STACK_PALETTE_05_ACCENT,
      background: STACK_PALETTE_05_BACKGROUND,
    },
    [STACK_PALETTE_06_ACCENT]: {
      accent: STACK_PALETTE_06_ACCENT,
      background: STACK_PALETTE_06_BACKGROUND,
    },
    [STACK_PALETTE_07_ACCENT]: {
      accent: STACK_PALETTE_07_ACCENT,
      background: STACK_PALETTE_07_BACKGROUND,
    },
    [STACK_PALETTE_08_ACCENT]: {
      accent: STACK_PALETTE_08_ACCENT,
      background: STACK_PALETTE_08_BACKGROUND,
    },
    [STACK_PALETTE_09_ACCENT]: {
      accent: STACK_PALETTE_09_ACCENT,
      background: STACK_PALETTE_09_BACKGROUND,
    },
    [STACK_PALETTE_10_ACCENT]: {
      accent: STACK_PALETTE_10_ACCENT,
      background: STACK_PALETTE_10_BACKGROUND,
    },
  };
  

  // /**
  //  * Compute a lighter shade (tint) of a hex color
  //  * Uses color blending with white at a specified ratio
  //  * 
  //  * @param hexColor - The hex color code (e.g., "#6C5CE7")
  //  * @param tintFactor - How much white to blend (0.85 = 85% white, very light)
  //  * @returns Lighter hex color
  //  */
  // const computeLighterShade = (hexColor: string, tintFactor: number = 0.85): string => {
  //   // Remove # if present and ensure uppercase
  //   const hex = hexColor.replace('#', '').toUpperCase();
    
  //   // Parse RGB values
  //   const r = parseInt(hex.substring(0, 2), 16);
  //   const g = parseInt(hex.substring(2, 4), 16);
  //   const b = parseInt(hex.substring(4, 6), 16);
    
  //   // Blend with white (255, 255, 255)
  //   // Formula: newColor = originalColor + (white - originalColor) * tintFactor
  //   const newR = Math.round(r + (255 - r) * tintFactor);
  //   const newG = Math.round(g + (255 - g) * tintFactor);
  //   const newB = Math.round(b + (255 - b) * tintFactor);
    
  //   // Convert back to hex
  //   const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();
  //   return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
  // };

  /**
 * Get color mapping for a given accent color
 * Used by StackCard component to apply border and background colors
 * 
 * For predefined palette colors, uses hand-picked lighter shades.
 * For custom colors (from ColorPicker), computes the lighter shade dynamically.
 * 
 * @param accentColor - The accent color hex code (e.g., "#6C5CE7")
 * @returns StackColorMapping object with accent and background colors
 */
export const getStackColorMapping = (accentColor: string | null | undefined): StackColorMapping => {
    if (!accentColor) {
      return DEFAULT_COLOR_MAPPING;
    }
    
    const normalizedColor = accentColor.toUpperCase().startsWith('#') 
      ? accentColor.toUpperCase() 
      : `#${accentColor.toUpperCase()}`;
    
    // Use pre-defined mapping if available (optimal hand-picked shades)
    if (STACK_COLOR_MAPPING[normalizedColor]) {
      return STACK_COLOR_MAPPING[normalizedColor];
    }

    return DEFAULT_COLOR_MAPPING;
    
    // For custom colors, compute the lighter shade dynamically
    // This handles colors from ColorPicker that aren't in the predefined palette
    // return {
    //   accent: normalizedColor,
    //   background: computeLighterShade(normalizedColor, 0.85)
    // };
}